import { ResourceCentrePageCategory } from '../../../types';
import { translations as healthCard } from './health-card';
import { translations as driversLicence } from './licence';
import { translations as paymentCards } from './payment-cards';
import { translations as rewardCards } from './reward-cards';
import { translations as serviceCards } from './service-cards';
import { translations as sinCard } from './sin-card';

export const translations: ResourceCentrePageCategory = {
  title: 'Lost or Stolen Item Recovery',
  items: {
    paymentCards,
    driversLicence,
    healthCard,
    serviceCards,
    sinCard,
    rewardCards
  }
};
